// src/pages/PrivacyPolicy/PrivacyPolicy.js
import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.privacyPage}>
      <div className={styles.container}>
        <h1 className={styles.pageTitle}>POLITIQUE DE CONFIDENTIALITÉ</h1>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Introduction</h2>
          <p>La présente Politique de Confidentialité décrit comment Le Poke collecte, utilise et protège les informations que vous nous fournissez lorsque vous utilisez notre site web.</p>
          <p>Nous nous engageons à protéger votre vie privée et à garantir la sécurité de vos informations personnelles conformément aux réglementations en vigueur (notamment le RGPD).</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Collecte des Informations Personnelles</h2>
          <p>Nous pouvons collecter les types d'informations personnelles suivants :</p>
          <ul>
            <li><strong>Informations d'identification :</strong> Nom, prénom, adresse e-mail, numéro de téléphone lorsque vous nous contactez via notre formulaire ou pour une commande.</li>
            <li><strong>Données de navigation :</strong> Informations relatives à votre utilisation du site (pages consultées, durée de la visite, etc.) via des outils d'analyse (Google Analytics, etc.).</li>
            <li><strong>Informations sur les favoris :</strong> Les éléments que vous ajoutez à votre liste de favoris sur notre site (stockés localement sur votre appareil via le navigateur).</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Utilisation de vos Informations</h2>
          <p>Les informations collectées sont utilisées pour :</p>
          <ul>
            <li>Traiter vos commandes et vos demandes de renseignements.</li>
            <li>Améliorer nos services et notre site web.</li>
            <li>Personnaliser votre expérience utilisateur (ex: maintenir votre liste de favoris).</li>
            <li>Vous envoyer des communications marketing (si vous y avez consenti).</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Partage des Informations</h2>
          <p>Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers. Nous pouvons partager vos informations avec des prestataires de services tiers qui nous aident à exploiter notre site web ou à mener nos activités, à condition que ces parties acceptent de garder ces informations confidentielles.</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Sécurité des Données</h2>
          <p>Nous mettons en œuvre diverses mesures de sécurité pour maintenir la sûreté de vos informations personnelles lorsque vous passez une commande ou que vous soumettez vos informations.</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Vos Droits</h2>
          <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition concernant vos données personnelles. Pour exercer ces droits, veuillez nous contacter à [Adresse e-mail de contact du restaurant].</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Cookies</h2>
          <p>Notre site web peut utiliser des "cookies" pour améliorer votre expérience. Vous pouvez choisir de configurer votre navigateur pour refuser les cookies, mais certaines parties du site pourraient ne pas fonctionner correctement.</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Consentement</h2>
          <p>En utilisant notre site, vous consentez à notre politique de confidentialité.</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Modifications de la Politique de Confidentialité</h2>
          <p>Le Poke se réserve le droit de modifier la présente politique de confidentialité à tout moment. Toute modification sera publiée sur cette page.</p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;